import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import {
  addFieldData,
  alertDialog,
  alertDialogGoToNext,
  setItemBreadcrumbs,
  setReturnedValue
} from "../actions";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  label: {
    color: "rgba(13, 162, 181, 1)",
    fontSize: "1.6rem",
    fontWeight: "500",
    display: "block"
  },
  select: {
    width: "100%"
  }
});

class WISelect extends Component {
  state = {
    value: "",
    dataValue: ""
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    this.props.setContentDialog("");
    this.props.setGoToNextDialog("");
    this.props.setCanGoToBeginning("");
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      return this.props.dataSource[dataKey];
    }
    return null;
  };

  getRenderSelect = data => {
    if (data) {
      return data.map(item => {
        return (
          <MenuItem
            key={item.key}
            value={item.value}
            datavalue={item.dataValue}
            datalabel={item.label}
          >
            {item.label}
          </MenuItem>
        );
      });
    }
    return [];
  };

  handleChange = event => {
    const returnedKey = this.props.step.returned.key;
    const label = event.currentTarget.attributes.datalabel.value;
    const returnedDataKey = this.props.step.returned.dataKey
      ? this.props.step.returned.dataKey
      : returnedKey;
    const value = event.target.value;
    const dataValue = event.currentTarget.attributes.datavalue
      ? event.currentTarget.attributes.datavalue.value
      : value;
    this.buildBreadcrumbs(label);
    if (returnedKey && value !== "") {
      this.props.isValid(true);
      this.props.setReturnedValue({
        [returnedKey]: value,
        [returnedDataKey]: dataValue
      });
    } else {
      this.props.isValid(false);
    }
    this.setState({ value, dataValue });
  };

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  render() {
    const { step, classes } = this.props;
    const stepData = step.data;
    let data = this.getData();
    if (data && stepData.formatSource) {
      data = stepData.formatSource(data);
    }
    return (
      <React.Fragment>
        {data && (
          <div className="custom-select wrap-input">
            <InputLabel className={classes.label}>
              {step.icon && <img src={step.icon} alt={step.label} />}
              {step.label}
            </InputLabel>
            <Select value={this.state.value} onChange={this.handleChange}>
              {this.getRenderSelect(data)}
            </Select>
          </div>
        )}
      </React.Fragment>
    );
  }
}

WISelect.propTypes = {
  activeStep: PropTypes.any,
  classes: PropTypes.shape({
    label: PropTypes.any
  }),
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  isValid: PropTypes.func,
  resetData: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setCanGoToBeginning: PropTypes.func,
  setContentDialog: PropTypes.func,
  setGoToNextDialog: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    returned: PropTypes.shape({
      dataKey: PropTypes.any,
      key: PropTypes.any
    })
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    setContentDialog: content => dispatch(alertDialog(content)),
    setGoToNextDialog: isGoToNext => dispatch(alertDialogGoToNext(isGoToNext)),
    setCanGoToBeginning: isGoToBeginning =>
      dispatch(alertDialogGoToNext(isGoToBeginning))
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WISelect)
);
